module.exports = "data:image/webp;base64,UklGRjoAAABXRUJQVlA4TC0AAAAvnEOiEAcQEREQkCT9/x9G9D/jP//5z3/+85///Oc///nPf/7zn//85z//xwQA"